'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var SvgIcon = require('../../library/DataDisplay/SvgIcon.js');
var iconStyles = require('../iconStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var CardOnFile = function CardOnFile(props) {
  return React__default["default"].createElement(SvgIcon, _objectSpread({}, props, {
    viewBox: "0 0 24 24"
  }), React__default["default"].createElement("g", null, React__default["default"].createElement("path", {
    d: "M22,3H2C0.9,3,0,3.9,0,5v14c0,1.1,0.9,2,2,2h20c1.1,0,2-0.9,2-2l0-14C24,3.9,23.1,3,22,3z M8,6c1.7,0,3,1.3,3,3s-1.3,3-3,3\n                  s-3-1.3-3-3S6.3,6,8,6z M14,18H2v-1c0-2,4-3.1,6-3.1s6,1.1,6,3.1V18z M22.5,11.2c0,0.5-0.4,0.9-0.9,0.9h-7c-0.5,0-0.9-0.4-0.9-0.9\n                  l0-5.2c0-0.5,0.4-0.9,0.9-0.9h7c0.5,0,0.9,0.4,0.9,0.9V11.2z"
  }), React__default["default"].createElement("rect", {
    x: "14.6",
    y: "8.6",
    width: "7",
    height: "2.6"
  }), React__default["default"].createElement("rect", {
    x: "14.6",
    y: "6",
    width: "7",
    height: "0.9"
  })));
};

var CardOnFile$1 = iconStyles()(CardOnFile);

module.exports = CardOnFile$1;
